export enum ListTypeEnum {
  TOTAL = 'TOTAL',
  UNDER_CONSIDERATION = 'UNDER_CONSIDERATION',
  AGREED = 'AGREED',
  EXCLUDED = 'EXCLUDED',
  APPEALED = 'APPEALED',
  COMMENTS_EXIST = 'COMMENTS_EXIST',
  FILL_IN_PROCESS = 'FILL_IN_PROCESS',
  READY_FOR_APPROVE = 'READY_FOR_APPROVE',
}
